import { SHOW_MODAL, HIDE_MODAL } from '../redux/types';

export const showModalNew = (modalType, modalProps = {}) => ({
  type: SHOW_MODAL,
  modalType,
  modalProps,
});

export const hideModal = () => ({
  type: HIDE_MODAL,
});
